import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import html2pdf from "html2pdf.js";
import { showSuccessToast, showLoadingToast, updateLoadingToastSuccess, updateLoadingToastError } from '../utils/toastConfig';
import "./InvoiceView.css";
import { getInvoice } from "../services/api";

const InvoiceView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const invoiceRef = useRef();

  const [invoice, setInvoice] = useState(null);

  useEffect(() => {
    const fetchInvoice = async () => {
      const { data } = await getInvoice(id);
      setInvoice(data);
    };
    fetchInvoice();
  }, [id]);

  const fmt = (v) => parseFloat(v).toLocaleString("en-IN") + "/-";

  const fmtDate = (d) => {
    const date = new Date(d);
    return `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${date.getFullYear()}`;
  };

  const download = () => {
    const toastId = showLoadingToast('Generating PDF...');
    try {
      html2pdf()
        .set({
          margin: 0,
          filename: `${invoice.invoice_number}.pdf`,
          html2canvas: { scale: 2 },
          jsPDF: { unit: "mm", format: "a4" }
        })
        .from(invoiceRef.current)
        .save();
      updateLoadingToastSuccess(toastId, 'Invoice downloaded successfully! ⬇️');
    } catch (error) {
      updateLoadingToastError(toastId, 'Failed to download invoice');
    }
  };

  const toWords = (num) => {
    const a = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven",
      "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen",
      "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];
    const b = [
      "", "", "Twenty", "Thirty", "Forty", "Fifty",
      "Sixty", "Seventy", "Eighty", "Ninety"
    ];
    if (num === 0) return "Zero";

    const convert = (n) => {
      if (n < 20) return a[n];
      if (n < 100) return b[Math.floor(n / 10)] + " " + a[n % 10];
      if (n < 1000)
        return a[Math.floor(n / 100)] + " Hundred " + convert(n % 100);
      if (n < 100000)
        return convert(Math.floor(n / 1000)) + " Thousand " + convert(n % 1000);
      if (n < 10000000)
        return convert(Math.floor(n / 100000)) + " Lakh " + convert(n % 100000);
      return convert(Math.floor(n / 10000000)) + " Crore " + convert(n % 10000000);
    };

    return convert(Math.round(num)).replace(/\s+/g, " ").trim();
  };

  if (!invoice) return null;

  const same = invoice.client_state?.toLowerCase() === "telangana";

  return (
    <div className="invoice-page">

<div className="action-bar no-print">

  <div className="header-left">
    <img src="/veramasalogo.png" alt="Veramasa" className="logo"/>
  </div>

  <div className="header-actions">
    <button className="back-btn" onClick={() => navigate("/dashboard")}>
      ← Back to Dashboard
    </button>

    <button className="download-btn" onClick={download}>
      Download PDF
    </button>
  </div>

</div>

      <div className="invoice-paper" ref={invoiceRef}>

        {/* WATERMARK */}
        <div className="watermark">
          <img src="/veramasalogo.png" alt="watermark"/>
        </div>

        {/* HEADER */}
        <div className="header">
          <img src="/veramasalogo.png" className="logo" alt="logo"/>
        </div>

        <div className="company-title">
          Veramasa IT and Education Consultancy PVT LTD
        </div>

        <div className="address">
          <b>Flat No 301, Art Lakshmi Residency, Gayatri Nagar, Borabanda, Hyderabad</b>
          <br/>
          <b>Telangana, India- 500018</b>
          Email:- info@veramasa.com &nbsp;&nbsp; Phone: +919059368510
        </div>

        <div className="title">TAX INVOICE</div>

        <table className="invoice-table">
          <tbody>

            <tr>
              <td colSpan="2" rowSpan="6" className="company-box">
                <b>VERAMASA IT AND EDUCATION CONSULTANCY PVT LTD.</b><br/>
                Information Technology and Consultancy services<br/>
                Flat No 301, Art Lakshmi Residency, Gayathri nagar,<br/>
                Borabanda, Hyderabad, Telangana, India- 500018
              </td>

              <td className="label">Invoice No</td>
              <td className="label">{invoice.invoice_number}</td>
            </tr>

            <tr>
              <td className="label">SAC CODE</td>
              <td className="label">{invoice.sac_code}</td>
            </tr>

            <tr>
              <td className="label">Date</td>
              <td className="label">{fmtDate(invoice.invoice_date)}</td>
            </tr>

            <tr>
              <td className="label">GSTN</td>
              <td className="label">36AAECV8279M1ZG</td>
            </tr>

            <tr>
              <td className="label">PAN No</td>
              <td className="label">AAECV8279M</td>
            </tr>

            <tr>
              <td className="label">PO NO</td>
              <td className="label">NIL</td>
            </tr>

            <tr>
  <td colSpan="2" className="center"><b>Customer</b></td>

  <td className="label">PO DATE</td>
  <td className="label">NIL</td>
</tr>

<tr>
  <td colSpan="2" rowSpan="4" className="customer-box">
    <b>{invoice.client_name}</b><br/>
    {invoice.client_address}<br/>
    <b style={{color:"red"}}>GSTN {invoice.client_gst}</b>
  </td>

  <td className="label">BANK</td>
  <td className="label">AXIS BANK</td>
</tr>

            <tr>
              <td className="label">Address</td>
              <td className="label">DD COLONY Hyderabad</td>
            </tr>

            <tr>
              <td className="label">Account Number</td>
              <td className="label">920020047084756</td>
            </tr>

            <tr>
              <td className="label">IFSC Code</td>
              <td className="label">UTIB0004188</td>
            </tr>

<tr>
  <td colSpan="2" style={{borderRight:"none"}}></td>
  <td className="center"><b>Category</b></td>
  <td className="center"><b>Service</b></td>
</tr>

<tr>
  <td colSpan="4"></td>
</tr>

            <tr className="service-head">
              <td>S.No</td>
              <td>Description</td>
              <td></td>
              <td>Total Value (INR)</td>
            </tr>

            <tr>
              <td className="center">1</td>
              <td>{invoice.description}</td>
              <td></td>
              <td className="right" style={{textAlign:"center"}}>{fmt(invoice.amount)}</td>
            </tr>

          <tr>
  <td colSpan="3" className="right" style={{textAlign:"right"}}>Sub Total</td>
  <td className="right" style={{textAlign:"center"}}>{fmt(invoice.amount)}</td>
</tr>

<tr>
  <td colSpan="3" className="right" style={{textAlign:"right"}}>CGST @ 9%</td>
  <td className="right" style={{textAlign:"center"}}>{same ? fmt(invoice.cgst) : "Nil"}</td>
</tr>

<tr>
  <td colSpan="3" className="right" style={{textAlign:"right"}}>SGST @ 9%</td>
  <td className="right" style={{textAlign:"center"}}>{same ? fmt(invoice.sgst) : "Nil"}</td>
</tr>
<tr> 
  <td colSpan="3" className="right" style={{textAlign:"right"}}><b>IGST @ 18%</b></td> 
<td className="right" style={{textAlign:"center"}}>{!same ? fmt(invoice.igst) : "Nil"}</td> </tr>
<tr>
  <td colSpan="3" className="right" style={{textAlign:"right", borderBottom:"none",borderRight:"none"}}>
    Grand Total
  </td>
  <td className="right" style={{borderBottom:"none",borderLeft:"none",textAlign:"center"}}>
    {fmt(invoice.total_amount)}
  </td>
</tr>

<tr>
  <td className="words" colSpan="4" style={{textAlign:"center", borderTop:"none"}}>
    Amount Chargeable ( in words ) :
    <i> INR {toWords(parseFloat(invoice.total_amount))} Only</i>
  </td>
</tr>

          </tbody>
        </table>

        {/* FOOTER */}
        <div className="invoice-footer">

          <img src="/seal.png" className="seal" alt="seal"/>

          <div className="sign-area">
            <div className="sub">
              For VERAMASA IT AND EDUCATION<br/>
              CONSULTANCY Pvt Ltd.
            </div>

            <img src="/sign.png" className="sign" alt="signature"/>

            <div className="auth">Authorized Signature</div>
          </div>

        </div>

        <div className="note">
          Described all particulars are true and correct.
        </div>

      </div>
    </div>
  );
};

export default InvoiceView;